import React,{useEffect, useState} from 'react'
import { Box, Button, FormHelperText, Stack, Typography } from '@mui/material';
import {useDropzone} from 'react-dropzone'
import Axios from 'axios'
import fileDownload from 'js-file-download'
import UploadFileIcon from '@mui/icons-material/UploadFile'; 
import { useSnackbar } from "notistack";
const CustomDropZoneDoc = ({setter,title,errors,files,edit,width,url,  accept,maxSize}) =>{

    const [file,setFile] = useState(files)
    const { enqueueSnackbar } = useSnackbar();
    const placeholderText="Drag Or click here to upload"
    const onDropRejected = (fileRejections) => {
    const error = fileRejections[0]?.errors?.[0];

    if (error?.code === "file-too-large") {
        enqueueSnackbar(`${title} must be less than 5MB.`, {
            variant: "error",
        });
    }
};
    const {getRootProps, getInputProps} = useDropzone({
        onDrop: acceptedFiles => {
            let d = (acceptedFiles.map(file => Object.assign(file, {preview: URL.createObjectURL(file)})))
            setFile(d[0])
            setter(d[0])
        },
          onDropRejected: onDropRejected,
        maxFiles:1,
          accept: accept,
          maxSize: maxSize
    });


   

    useEffect(()=>{
        setFile(files);
    },[files]);
    function download(url, filename) {
        Axios.get(url, {
          responseType: 'blob',
        }).then(res => {
          fileDownload(res.data, filename);
        });
      }


    return(
        <Stack spacing={1} >
            <Typography variant='label'>{title}</Typography>
            <Stack direction={'row'} spacing={1} >
            <Box {...getRootProps({className: 'dropzone',onClick: event => !edit ? event.stopPropagation():""})} sx={{display:'flex',justifyContent:'center',alignItems:'center',width:width? width : '100%',height:46,
                    borderRadius:'8px',border:'1px dashed #C6CDD5',backgroundColor:'#F8F8F8',padding:'10px','&:hover':{cursor:'pointer'}}} >
                    <input {...getInputProps()}  />
                    {!file && (
                        <UploadFileIcon sx={{fontSize: '25px'}} />
                    )}
                    <Typography variant={file?'body2':'placeHolder'} sx={{ padding: '0 10px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                      {file ? ((file?.name?.split('圓')[1]) ? (file?.name?.split('圓')[1]) : file?.name.substring(0,80)):placeholderText}
                    </Typography>
            </Box>
            {
                url ? 
                <Button disabled={files == null} variant="contained" 
                onClick={()=>download(url,file?.name?.split('圓')[1])}
                // onClick={()=> window.open(url)}
                >Download</Button>
                :""
            }
            </Stack>
            <FormHelperText sx={{color:'red'}}>{errors}</FormHelperText>
        </Stack>
    )
}
export default CustomDropZoneDoc